import { gql } from '@apollo/client'

export const Query = gql`
  query EditAccommodation($companyId: ID!, $filters: AccommodationFilters) {
    accommodations(companyId: $companyId, filters: $filters) {
      nodes {
        id
        address1
        address2
        address3
        city
        county
        country
        postcode
        name
      }
    }
  }
`
